import { render, staticRenderFns } from "./CrueltyBoard.vue?vue&type=template&id=702b6f3e&"
import script from "./CrueltyBoard.vue?vue&type=script&lang=js&"
export * from "./CrueltyBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports